<script>
import { Bar,mixins } from 'vue-chartjs'

export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    const chartdata = this.chartData || {chartData: []};
    this.renderChart(chartdata, this.options)
  }
}</script>

<style lang="scss" scoped>
</style>